const DEFAULT_TIMEOUT_MS = 5000;

const scheduleAutoDismiss = () => {
    const notices = document.querySelectorAll('[data-auto-dismiss-ms]');

    notices.forEach((notice) => {
        if (notice.dataset.dismissScheduled === 'true') {
            return;
        }

        const closeButton = notice.querySelector('button.fr-btn--close, button.btn-close');
        if (!closeButton) {
            return;
        }

        const timeout = Number.parseInt(notice.dataset.autoDismissMs || `${DEFAULT_TIMEOUT_MS}`, 10);
        if (Number.isNaN(timeout) || timeout <= 0) {
            return;
        }

        notice.dataset.dismissScheduled = 'true';
        setTimeout(() => {
            closeButton.click();
        }, timeout);
    });
};

document.addEventListener('DOMContentLoaded', scheduleAutoDismiss);
document.addEventListener('turbo:load', scheduleAutoDismiss);

// Fermeture des alertes (fr-alert) et bandeaux (fr-notice) DSFR.
// Délégation sur le document : fonctionne aussi pour les éléments insérés
// dynamiquement (Turbo Streams) et évite les onclick en dur dans les vues.
document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('button.fr-btn--close');
    // Les boutons de fermeture des modales (aria-controls) sont gérés par le JS du DSFR.
    if (!closeButton || closeButton.hasAttribute('aria-controls')) {
        return;
    }

    const dismissible = closeButton.closest('.fr-alert, .fr-notice');
    if (dismissible) {
        dismissible.remove();
    }
});
